import { Button } from "@/components/ui/button";
import { useSourceDeals } from "@/hooks/service-hooks/deals/use-won-deals";
import { getHubspotDealHref } from "@/utils/get-hubspot-deal-href";
import { ExternalLink, Link2 } from "lucide-react";
import { Link } from "react-router-dom";

interface SourceDealActionsProps {
  sourceDealId?: string;
}

export function SourceDealActions(
  props: Readonly<SourceDealActionsProps>,
) {
  const { sourceDealId } = props;
  const sourceDealsQuery = useSourceDeals(sourceDealId ? [sourceDealId] : []);
  const sourceDeal = sourceDealsQuery.data?.[0];
  const crmHref = getHubspotDealHref({
    dealId: sourceDealId,
    hubspotLink: sourceDeal?.hubspotLink,
  });

  if (!sourceDealId) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      <Button asChild size="sm" variant="outline">
        <Link to={`/deals?dealId=${sourceDealId}`}>
          View Source Deal
          <Link2 className="h-4 w-4" />
        </Link>
      </Button>
      {crmHref ? (
        <Button asChild size="sm" variant="outline">
          <Link to={crmHref} target="_blank" rel="noreferrer">
            Open in CRM
            <ExternalLink className="h-4 w-4" />
          </Link>
        </Button>
      ) : null}
    </div>
  );
}
